import { render } from "./proposal-modal.vue?vue&type=template&id=35b335b2&scoped=true"
import script from "./proposal-modal.vue?vue&type=script&lang=js"
export * from "./proposal-modal.vue?vue&type=script&lang=js"

import "./proposal-modal.vue?vue&type=style&index=0&id=35b335b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b335b2"]])

export default __exports__